import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptPersonDetail } from "../adapters/adaptPersonDetail";

const fetchPersonProfile = async (id: string) => {
	const response = await cmsClient.get<IPersonProfile>(
		`/homepage/admin/store/user/${id}/profile/`
	);

	return response.data;
};

const usePersonProfile = (id: string, options?: { enabled?: boolean }) => {
	const query = useQuery(["person-profile", id], () => fetchPersonProfile(id), {
		select: adaptPersonDetail,
		enabled: options?.enabled !== undefined ? options.enabled : !!id
	});

	return query;
};

export default usePersonProfile;
